import Vue from 'vue'
import capitalize from '../helpers/capitalize'

Vue.filter('capitalize', function (value) {
  return capitalize(value)
})
